export default __webpack_public_path__ + "static/media/gearIcon.712bccf8.svg";